import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { FOR_BANK_MAX_LENGTHS, FOR_BANK_SECTIONS } from 'constants/businessToolSections/forBank';
import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { getDocumentType } from 'helpers/getDocumentType';
import { concatWithDot } from 'helpers/string';

import { StagesComponent } from './components/StagesComponent';
import { IMPLEMENTATION_PLAN_NAMES, prefix, stagesInitialValues } from './utils/form';

export const ImplementationPlan: FC = () => {
  const { t } = useTranslation();
  const type = useBusinessToolStore(getBusinessPlanType);
  const isOnePage = getDocumentType(type) === BUSINESS_PLAN_TYPES.ONE_PAGE;

  const businessToolSection = isOnePage ? ONE_PAGE_SECTIONS.IMPLEMENTATION_PLAN : FOR_BANK_SECTIONS.IMPLEMENTATION_PLAN;

  const canAccess = useCheckSubSectionAccess(businessToolSection);

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader locked={!canAccess} title={t('implementationPlan.title')} />
      </FormSectionCard>
      <FormSectionCard collapsible disabled={!canAccess} title={t('implementationPlan.stages.title')}>
        <FieldArrayComponent
          name={concatWithDot(prefix, IMPLEMENTATION_PLAN_NAMES.STAGES)}
          initialItem={stagesInitialValues}
          buttonText={t('implementationPlan.stages.stage')}
          disabled={!canAccess}
          maxLength={10}
        >
          {(namePrefix, _, remove) => (
            <StagesComponent
              maxLength={FOR_BANK_MAX_LENGTHS.IMPLEMENTATION_PLAN.STAGE}
              multiline
              hiddenLabel
              name={namePrefix}
              disabled={!canAccess}
              onRemove={remove}
            />
          )}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
